import dynamic from 'next/dynamic';
import { Container, MapTo } from '@adobe/aem-react-editable-components';

/* eslint-disable @nx/enforce-module-boundaries */
import '../../libs/aemComponents/Container'; // TODO: Why are these imports not aliased?
import '../../libs/aemComponents/ExperienceFragment';
import {
  EditableHTLWrapper,
  StaticWrapper,
  CardHorizontalMini,
  CardLayered,
  CardVertical,
  CardCarouselContainer,
  CardHorizontalFeature,
  BannerLayered,
  BrandRibbon,
  IconBlock,
  AccordionContainer,
  LinkBanner,
  CobrandCardHorizontalFlexible,
  Hero,
  Footer,
  // LinkList,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  GeneralMessage,
  ProtectedContainer,
} from '@marriott/mi-common-static-components';
/* eslint-enable @nx/enforce-module-boundaries */
import { AEMText, SearchFormEditable } from '@marriott/mi-shop-components';
import { OfferCardCarousel } from '@marriott/mi-offers-components';
import {
  CarouselContainerSkeletonLoader,
  BannerLayeredSkeletonLoader,
  CardHorizontalMiniSkeletonLoader,
  HeroBanner,
  IconFeatureBanner,
  PropertyBarWrapper,
  StickyComponentWrapper,
  Postcard,
  PostcardContainer,
  ThemeCluster,
  ThemeClusterCarousel,
  ProductDetailsCard,
  SixPackContainer,
  TabbedLayout,
  DynamicTabbedLayout,
  EnrollmentCardContainer,
  CNAnimatedBanner,
} from '@marriott/mi-homepage-components';
import {
  MerchandisingSmallBanner,
  MerchandisingHeroBanner,
  MerchandisingDCAContainer,
  DCADecisionContainer,
  RiottMediaCard,
  MerchandisingCarouselContainer,
  MerchandisingCardTile,
} from '@marriott/mi-merch-components';
import { POLARIS_CONSTANTS } from '@marriott/mi-homepage-components';

const CardCarouselContainerDynamic = dynamic(
  () => import('@marriott/mi-common-static-components').then(module => module.CardCarouselContainer),
  {
    ssr: true,
    loading: () => <CarouselContainerSkeletonLoader />,
  }
);

const CardHorizontalMiniDynamic = dynamic(
  () => import('@marriott/mi-common-static-components').then(module => module.CardHorizontalMini),
  {
    ssr: true,
    loading: () => <CardHorizontalMiniSkeletonLoader />,
  }
);

const BannerLayeredDynamic = dynamic(
  () => import('@marriott/mi-common-static-components').then(module => module.BannerLayered),
  {
    ssr: true,
    loading: () => <BannerLayeredSkeletonLoader />,
  }
);

const FooterDynamic = dynamic(() => import('@marriott/mi-common-static-components').then(module => module.Footer), {
  ssr: true,
});

// TODO: AEM component paths are having issues when picked using ENV vars
// Needs to be investigated as tech debt
export const AEM_REACT_MAPPING = {
  ['mi-aem-common-spa/components/content/generalmessage']: GeneralMessage,
  [`mi-aem-homepage-spa/components/text`]: AEMText,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-homepage-spa/components/content/herobanner`]: HeroBanner,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`]: SearchFormEditable,
  [`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`]: SearchFormEditable,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: CobrandCardHorizontalFlexible,
  [`mi-aem-offers-spa/components/offers-cards`]: OfferCardCarousel,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-homepage-spa/components/content/iconfeaturebanner`]: IconFeatureBanner,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
  [`mi-aem-homepage-spa/components/content/postcard`]: Postcard,
  [`mi-aem-homepage-spa/components/content/postcardcontainer`]: PostcardContainer,
  [`mi-aem-homepage-spa/components/content/themed-cluster`]: ThemeCluster,
  [`mi-aem-homepage-spa/components/content/cardcarouselcontainer`]: ThemeClusterCarousel,
  [`mi-aem-homepage-spa/components/content/propertybar`]: PropertyBarWrapper,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-common-spa/components/content/merchandisingherobanner`]: MerchandisingHeroBanner,
  [`mi-aem-common-spa/components/content/dcaabtestwrapper`]: MerchandisingDCAContainer,
  [`mi-aem-common-spa/components/content/protectedcontainer`]: ProtectedContainer,
  [`mi-aem-homepage-spa/components/content/product-detail-cards`]: ProductDetailsCard,
  [`mi-aem-homepage-spa/components/content/sixpackcontainer`]: SixPackContainer,
  [`mi-aem-homepage-spa/components/content/tabbedlayout`]: TabbedLayout,
  [`mi-aem-homepage-spa/components/content/dynamictabbedlayout`]: DynamicTabbedLayout,
  [`mi-aem-homepage-spa/components/content/enrollmentcard`]: EnrollmentCardContainer,
  [`mi-aem-common-spa/components/content/dcadecisioncontainer`]: DCADecisionContainer,
  ['mi-aem-common-spa/components/content/mangopilot']: RiottMediaCard,
  ['mi-aem-common-spa/components/content/riottmediacard']: RiottMediaCard,
  [`mi-aem-common-spa/components/content/tilecarouselcontainer`]: MerchandisingCarouselContainer,
  [`mi-aem-common-spa/components/content/tilesquare`]: MerchandisingCardTile,
  [`mi-aem-common-spa/components/content/animatedbanner`]: CNAnimatedBanner,
};

export const defineComponentMapping = (allowedComponents, pagePath, isAuthorMode, pageProps, featureFlags) => {
  const { experience_mcom_carousel_lightining_variants: homepageCarouselFeatureFlags = {} } = featureFlags || {};
  const { carousel_switch_homepage = false } = homepageCarouselFeatureFlags;
  const homepageCarouselFromLightning =
    (pageProps?.query?.lightning === 'true' || carousel_switch_homepage === true) &&
    !pageProps?.requestUri?.includes('/preview');

  MapTo('mi-aem-common-spa/components/content/generalmessage')(GeneralMessage);
  MapTo(`mi-aem-homepage-spa/components/text`)(AEMText);
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(HeroBanner);
  MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(props => (
    <HeroBanner {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(props => (
    <CardLayered {...props} featureFlagLogo={featureFlags.featureFlagLogo} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
  MapTo(`mi-aem-common-spa/components/content/linkbanner`)(LinkBanner);
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
    isAuthorMode ? CardHorizontalMini : CardHorizontalMiniDynamic
  );
  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props =>
    isAuthorMode ? (
      <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ) : (
      <CardCarouselContainerDynamic {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    )
  );
  MapTo(`mi-aem-homepage-spa/components/content/themed-cluster`)(props => (
    <ThemeCluster {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-homepage-spa/components/content/cardcarouselcontainer`)(props => (
    <ThemeClusterCarousel {...props} allowedComponents={allowedComponents} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);
  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(isAuthorMode ? BannerLayered : BannerLayeredDynamic);
  MapTo(`mi-aem-common-spa/components/content/brandribbon`)(props => (
    <BrandRibbon {...props} featureFlagLogo={featureFlags.featureFlagLogo} />
  ));
  MapTo(`mi-aem-homepage-spa/components/content/propertybar`)(props => (
    <PropertyBarWrapper {...props} locale={pageProps.currentLocale} isAuthorMode={isAuthorMode} />
  ));

  MapTo(`mi-aem-common-spa/components/content/dcadecisioncontainer`)(
    props => <DCADecisionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'DCA Wrapper',
      isEmpty: false,
    }
  );
  MapTo('mi-aem-common-spa/components/content/mangopilot')(props => {
    return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
  });

  MapTo('mi-aem-common-spa/components/content/riottmediacard')(props => {
    return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
  });

  MapTo('mi-aem-common-spa/components/content/tilecarouselcontainer')(
    props => <MerchandisingCarouselContainer {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Tile Carousel Container',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/tilesquare`)(MerchandisingCardTile, {
    emptyLabel: 'Tile Square',
    isEmpty: false,
  });
  // Always wrap SearchForm with StickyComponentWrapper; switch behavior by hasGlobalNav
  const getSearchFormComponent = props => {
    const responsivegrid = pageProps.model?.cqItems?.root?.[':items']?.responsivegrid;
    const isNorthStar = pageProps.model.isNorthStarPage || false;
    const hasGlobalNav = Object.values(responsivegrid?.[':items'] || {}).some(c => c.id === 'hp-global-navigation');
    const { POLARIS_TAB_TITLE_ID, SEARCH_FOCUS_EVENT, SEARCH_BLUR_EVENT } = POLARIS_CONSTANTS;

    const handleFocus = () => {
      window.dispatchEvent(new Event(SEARCH_FOCUS_EVENT));
    };
    const handleBlur = () => {
      window.dispatchEvent(new Event(SEARCH_BLUR_EVENT));
    };
    const northStarProps = {
      'aria-labelledby': POLARIS_TAB_TITLE_ID,
      onFocus: handleFocus,
      onBlur: handleBlur,
    };

    return hasGlobalNav ? (
      <StickyComponentWrapper
        isNorthStar={isNorthStar}
        {...(isNorthStar && northStarProps)}
        hasGlobalNav={hasGlobalNav}
        {...props}
      >
        {(isSticky, refCallback) => (
          <SearchFormEditable
            {...props}
            currentLocale={pageProps.currentLocale}
            isSticky={isSticky}
            isPositionedExternally={true}
            refCallback={refCallback}
          />
        )}
      </StickyComponentWrapper>
    ) : (
      <SearchFormEditable {...props} currentLocale={pageProps.currentLocale} />
    );
  };
  MapTo(`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`)(getSearchFormComponent);
  MapTo(`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`)(getSearchFormComponent);
  MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock);
  MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(props => (
    <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(CobrandCardHorizontalFlexible);
  MapTo(`mi-aem-offers-spa/components/offers-cards`)(
    props => (
      // Rename to address broken homepage build caused by DXP-7950
      <OfferCardCarousel
        {...props}
        offersData={pageProps.productSpecificResponse}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.currentLocale}
        requestId={pageProps?.requestId}
        cookie={pageProps?.headersData['cookie']}
        isLightning={homepageCarouselFromLightning}
      />
    ),
    {
      emptyLabel: 'Offers Card Carousel',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/hero`)(Hero);
  MapTo(`mi-aem-homepage-spa/components/content/iconfeaturebanner`)(IconFeatureBanner);

  MapTo(`mi-aem-homepage-spa/components/content/postcard`)(props => (
    <Postcard {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-homepage-spa/components/content/postcardcontainer`)(props => (
    <PostcardContainer {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(props =>
    isAuthorMode ? (
      <Footer {...props} isAuthorMode={isAuthorMode} />
    ) : (
      <FooterDynamic {...props} isAuthorMode={isAuthorMode} />
    )
  );
  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(props => (
    <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlags.featureFlagLogo} />
  ));
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);

  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
    props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MerchandesingSmallBanner',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/merchandisingherobanner`)(
    props => (
      <MerchandisingHeroBanner {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlags.featureFlagLogo} />
    ),
    {
      emptyLabel: 'MerchandisingHeroBanner',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/dcaabtestwrapper`)(
    props => <MerchandisingDCAContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'DCA AB Test Wrapper',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/protectedcontainer`)(props => (
    <ProtectedContainer {...props} isAuthorMode={isAuthorMode} />
  ));

  MapTo(`mi-aem-homepage-spa/components/content/product-detail-cards`)(props => (
    <ProductDetailsCard {...props} isAuthorMode={isAuthorMode} />
  ));

  MapTo(`mi-aem-homepage-spa/components/content/sixpackcontainer`)(props => (
    <SixPackContainer {...props} isAuthorMode={isAuthorMode} />
  ));

  MapTo(`mi-aem-homepage-spa/components/content/tabbedlayout`)(props => (
    <TabbedLayout {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-homepage-spa/components/content/dynamictabbedlayout`)(props => (
    <DynamicTabbedLayout {...props} isAuthorMode={isAuthorMode} />
  ));

  MapTo(`mi-aem-homepage-spa/components/content/enrollmentcard`)(props => (
    <EnrollmentCardContainer {...props} isAuthorMode={isAuthorMode} />
  ));

  MapTo(`mi-aem-common-spa/components/content/animatedbanner`)(props => (
    <CNAnimatedBanner {...props} isAuthorMode={isAuthorMode} />
  ));

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.replace(pagePath, '').replace(baseModelPath, '');

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
